import React from "react";
import brand from "../content/brand";

const pad = (n) => String(n).padStart(2, "0");

const Sectors = () => (
  <div className="sectors">
    {brand.industries.map((name, i) => (
      <div key={name} className="item">
        <div className="id">SECTOR / {pad(i + 1)}</div>
        <div className="nm">{name}</div>
      </div>
    ))}
  </div>
);

export default Sectors;
